import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from "lucide-react";
import { footerLinks } from "../mock";

const LINK_PATHS = {
  "Privacy Policy": "/privacy",
  "Terms of Service": "/terms",
  "Risk Disclosure": "/risk-disclosure",
};

const Footer = () => {
  return (
    <footer className="border-t border-white/5 mt-20">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16">
        <div className="grid lg:grid-cols-6 gap-10 mb-12">
          <div className="lg:col-span-2">
            <a href="/" className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#3b59ff] to-[#1c3df5] flex items-center justify-center">
                <div className="w-3 h-3 rounded-full bg-white/95"></div>
              </div>
              <span className="font-display font-bold text-xl">Northwind</span>
            </a>
            <p className="bb-text-mute text-[14px] leading-relaxed mb-6 max-w-sm">
              Northwind is a top-rated forex broker with powerful trading tools, tight spreads, and live support. Sign up today to start trading.
            </p>
            <div className="flex gap-3">
              {[Facebook, Twitter, Instagram, Youtube, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/10 hover:border-white/30 hover:bg-white/5 flex items-center justify-center text-white/70 hover:text-white transition-all"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, items]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-[14px] mb-4">{title}</h4>
              <ul className="space-y-3">
                {items.map((it) => (
                  <li key={it}>
                    {LINK_PATHS[it] ? (
                      <Link to={LINK_PATHS[it]} className="text-[13px] bb-text-mute hover:text-white transition-colors">
                        {it}
                      </Link>
                    ) : (
                      <a href="#" className="text-[13px] bb-text-mute hover:text-white transition-colors">
                        {it}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/5 pt-8 mb-8">
          <p className="text-[11px] text-white/40 leading-relaxed mb-4">
            <strong className="text-white/55">Risk Warning:</strong> Trading derivatives and leveraged products carries a high level of risk, including the risk of losing substantially more than your initial investment. It is not suitable for everyone. Before making any investment decisions, you should seek advice from an independent financial advisor to ensure you understand the risks involved.
          </p>
          <p className="text-[11px] text-white/40 leading-relaxed">
            The information on this website is general in nature and does not constitute personal financial advice. Please read the legal documents before making any decisions.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-[12px] text-white/40">
          <div>© {new Date().getFullYear()} Northwind Markets. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white transition-colors">Sitemap</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
            <a href="#" className="hover:text-white transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
